import { Tabs, type Tab } from "shared/components/BaseTabs";
import {
  ACTOR_FILTER_LABELS,
  ACTOR_FILTER_ORDER,
  ActorFilter
} from "../constants";

export const ActorFilterTabs = ({
  filter,
  onChange
}: {
  filter: ActorFilter;
  onChange: (filter: ActorFilter) => void;
}) => {
  const tabs: Tab<ActorFilter>[] = ACTOR_FILTER_ORDER.map((value) => ({
    value,
    label: ACTOR_FILTER_LABELS[value]
  }));

  return (
    <Tabs
      tabStyle="line"
      size="sm"
      fullWidthTabs={false}
      active={filter}
      onChange={onChange}
      tabs={tabs}
      className="!gap-6"
    />
  );
};
